/*
 * blog-filter.js -- filtr rubrik na výpisu blogu (plán 14-01).
 *
 * PŘENOS 1:1 z `navrh-th-blog.html` ř. 1389-1408 (kotva ověřená `sed -n`
 * před psaním). Logika je návrhová beze zbytku: přepnutí třídy `on` na
 * kliknutém chipu, `hide` na kartách jiné rubriky, dorovnání dvou CTA
 * dlaždic podle počtu viditelných karet.
 *
 * JEDINÁ ZMĚNA OPROTI NÁVRHU: `event.preventDefault()`
 *
 * Návrh má chipy jako `<button>` bez cíle. Skutečná stránka je má jako
 * `<a href="/blog/category/{slug}">`, protože bez JS musí filtr fungovat
 * jako obyčejná navigace (kontrakt B: „bez JS web funguje"). Bez
 * `preventDefault()` by kliknutí zároveň přefiltrovalo DOM I odešlo
 * prohlížeč pryč -- uživatel by viděl bliknutí a pak úplně jinou stránku.
 * `href` přitom ZŮSTÁVÁ nedotčený: potlačuje se navigace, ne adresa.
 *
 * CO TENHLE MODUL NENÍ: ZDROJ OBSAHU. Server vypíše karty i chipy sám;
 * skript jen schovává. Bez něj (starý engine, chyba v jiném modulu) je
 * na stránce pořád celý výpis a chipy vedou na skutečné adresy rubrik.
 *
 * MIMO BLOG NEDĚLÁ NIC. První řádek hledá `.bposts`; když ho nenajde,
 * modul se vrátí dřív, než zaregistruje jediný posluchač.
 *
 * ŘETĚZEC „Vše" JE DOSLOVNÝ, TAK JAKO V NÁVRHU. Musí se bajt po bajtu
 * shodovat s `data-c` chipu, který vypisuje `terrahunt_2026_blog_chip_list()`
 * z registru textů (klíč `blog_widget_all`). Provider a tenhle modul jsou
 * proto dvě strany téhož kontraktu; chip „Vše" navíc nese `data-all="1"`,
 * takže se rozpoznává i tehdy, kdyby majitel text v registru přepsal.
 */

const VSE = 'Vše';

export function init() {
	if ( ! document.querySelector( '.bposts' ) ) {
		return;
	}

	const posts = [].slice.call( document.querySelectorAll( '.bpost' ) );
	const tags = [].slice.call( document.querySelectorAll( '.btag' ) );
	const siroka = document.querySelector( '.ctacard' );
	const mini = document.querySelector( '.ctamini' );

	if ( ! tags.length ) {
		return;
	}

	/*
	 * CTA karty se rovnají podle počtu VIDITELNÝCH článků, jinak by po
	 * odfiltrování zůstávaly viset v prázdné mřížce nebo by se v rohu
	 * znovu otevřela díra (poznámka autora návrhu u ř. 1396).
	 */
	function srovnej( vse ) {
		const videt = posts.filter( function ( p ) {
			return ! p.classList.contains( 'hide' );
		} ).length;

		if ( siroka ) {
			siroka.classList.toggle( 'hide', ! vse );
		}

		if ( mini ) {
			mini.classList.toggle( 'hide', videt % 2 === 0 );
		}
	}

	function jeVse( el ) {
		return el.hasAttribute( 'data-all' ) || el.dataset.c === VSE;
	}

	tags.forEach( function ( t ) {
		t.addEventListener( 'click', function ( e ) {
			e.preventDefault();

			const c = t.dataset.c;
			const vse = jeVse( t );

			tags.forEach( function ( x ) {
				x.classList.toggle( 'on', x === t );
			} );

			posts.forEach( function ( p ) {
				p.classList.toggle( 'hide', ! vse && p.dataset.c !== c );
			} );

			srovnej( vse );
		} );
	} );

	srovnej( true );
}
